/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/prop-types */
/* eslint-disable no-continue */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-empty */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect, useCallback, useRef } from "react";
import DashboardLayout from "pages/LayoutContainers/DashboardLayout";
import DashboardNavbar from "pages/Navbars/DashboardNavbar";
import { Box, Button, CircularProgress, IconButton, TextField, Typography } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { useNativeAuth } from "context/NativeAuthContext";
import { protectedResources } from "authConfig";

const API = protectedResources.apiTodoList.endpoint;
const SCOPES = protectedResources.apiTodoList.scopes?.[0]
  ? [protectedResources.apiTodoList.scopes[0]]
  : [];

// Prioritisation-matrix rating colours (VL→E), matching the dashboard/theme badges.
const RATING_COLORS = { VL: "#c8e6c9", L: "#388e3c", M: "#fdd835", H: "#ef6c00", E: "#c62828" };

// ── Token helper ──────────────────────────────────────────────────────────────

function useAuthToken() {
  const { instance } = useMsal();
  const { getAccessToken: getNativeAccessToken } = useNativeAuth();

  const getToken = useCallback(async () => {
    const native = getNativeAccessToken();
    if (native) return native;
    const account = instance.getActiveAccount();
    if (account && SCOPES.length) {
      const silent = await instance.acquireTokenSilent({ scopes: SCOPES, account });
      return silent?.accessToken || null;
    }
    return null;
  }, [instance, getNativeAccessToken]);

  return getToken;
}

// ── Streaming fetch ───────────────────────────────────────────────────────────

async function streamMessage(url, body, token, onEvent) {
  const res = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";

  // eslint-disable-next-line no-constant-condition
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const lines = buf.split("\n");
    buf = lines.pop();
    for (const line of lines) {
      if (!line.startsWith("data:")) continue;
      const payload = line.slice(5).trim();
      if (!payload) continue;
      try {
        onEvent(JSON.parse(payload));
      } catch (_) {}
    }
  }
}

// ── Action proposal card ──────────────────────────────────────────────────────

// Rendered when the advisor proposes an action (create watchlist risk / horizon search).
// Nothing is created until the user clicks the confirm button.
const REPORT_TYPE_LABEL = {
  strategic: "Strategic (board)",
  operational: "Operational",
  tactical: "Tactical / action",
};

const LENGTH_LABEL = {
  short: "Short (~1 page)",
  standard: "Standard (~2 pages)",
  detailed: "Detailed (~4 pages)",
};

// Human-readable reporting period for a board_paper proposal.
function boardPaperPeriodLabel(data) {
  if (data.dateFrom && data.dateTo) return `${data.dateFrom} → ${data.dateTo}`;
  const m = Number(data.periodMonths);
  if (m > 0) return `Last ${m} month${m === 1 ? "" : "s"}`;
  return "Current snapshot";
}

function ProposalCard({ proposal, onConfirm, onDismiss, onOpen, onOpenBoardPaper }) {
  const { kind, data = {}, busy, done, error, result } = proposal;
  const isRisk = kind === "risk";
  const isBoardPaper = kind === "board_paper";

  let heading = "Create this horizon scan search?";
  if (isRisk) heading = "Add this to your watchlist?";
  else if (isBoardPaper) heading = "Generate this board paper?";

  let threatType = "";
  if (data.threatOpp === "gain") threatType = "Opportunity";
  else if (data.threatOpp === "loss") threatType = "Threat";

  let rows = [
    ["Search", data.name],
    ["Category", data.category],
    ["Cadence", data.ingestTier === "instant" ? "Instant" : "Daily"],
    ["Criticality", data.criticality],
  ];
  if (isRisk) {
    rows = [
      ["Risk", data.title],
      ["Category", [data.category, data.subCategory].filter(Boolean).join(" › ")],
      ["Time frame", data.timeFrame],
      ["Type", threatType],
    ];
  } else if (isBoardPaper) {
    let focus = "Whole portfolio";
    if (Array.isArray(data.focusRisks) && data.focusRisks.length) {
      focus = data.focusRisks.join(", ");
    } else if (Array.isArray(data.focusCategories) && data.focusCategories.length) {
      const l2 =
        Array.isArray(data.focusSubCategories) && data.focusSubCategories.length
          ? ` › ${data.focusSubCategories.join(", ")}`
          : "";
      focus = `${data.focusCategories.join(", ")}${l2}`;
    }
    rows = [
      ["Depth", REPORT_TYPE_LABEL[data.reportType] || REPORT_TYPE_LABEL.strategic],
      ["Focus", focus],
      ["Period", boardPaperPeriodLabel(data)],
      ["Length", LENGTH_LABEL[data.length] || LENGTH_LABEL.standard],
      ["Charts", data.includeCharts === false ? "No" : "Yes"],
      ["Format", data.outputFormat === "pptx" ? "Slides (PPTX)" : "Word (DOCX)"],
    ];
  }

  if (done) {
    return (
      <Box
        sx={{
          alignSelf: "flex-start",
          maxWidth: "90%",
          border: "1px solid #c8e6c9",
          bgcolor: "#f1f8f2",
          borderRadius: 2,
          px: 1.5,
          py: 1,
          fontSize: 14,
          color: "#1b5e20",
        }}
      >
        <Box>
          {isRisk && `Added “${data.title}” to your watchlist as a draft.`}
          {isBoardPaper && "Your board paper is ready."}
          {!isRisk && !isBoardPaper && `Created the “${data.name}” horizon scan search.`}
        </Box>
        {isRisk && result && result.id && (
          <Button
            size="small"
            variant="text"
            onClick={() => onOpen && onOpen(result.id)}
            sx={{
              mt: 0.5,
              p: 0,
              minWidth: 0,
              color: "#52009b",
              textTransform: "none",
              fontWeight: 700,
            }}
          >
            Open risk →
          </Button>
        )}
        {isBoardPaper && result && result.reportId && (
          <Button
            size="small"
            variant="text"
            onClick={() => onOpenBoardPaper && onOpenBoardPaper(result.reportId)}
            sx={{
              mt: 0.5,
              p: 0,
              minWidth: 0,
              color: "#52009b",
              textTransform: "none",
              fontWeight: 700,
            }}
          >
            Open board paper →
          </Button>
        )}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        alignSelf: "flex-start",
        maxWidth: "90%",
        border: "1px solid rgba(82,0,155,0.35)",
        bgcolor: "#fff",
        borderRadius: 2,
        px: 1.5,
        py: 1.25,
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
      }}
    >
      <Typography
        variant="caption"
        sx={{ fontWeight: 700, color: "#52009b", letterSpacing: 0.3, display: "block", mb: 0.75 }}
      >
        {heading}
      </Typography>
      {rows
        .filter(([, v]) => v)
        .map(([label, v]) => (
          <Box key={label} sx={{ display: "flex", gap: 1, py: 0.25, fontSize: 13 }}>
            <Typography sx={{ minWidth: 82, color: "#7b809a", fontSize: 13, flexShrink: 0 }}>
              {label}
            </Typography>
            <Typography sx={{ color: "#344767", fontSize: 13, fontWeight: 500 }}>{v}</Typography>
          </Box>
        ))}
      {data.description && (
        <Typography sx={{ color: "#4a4658", fontSize: 12.5, mt: 0.5, lineHeight: 1.45 }}>
          {data.description}
        </Typography>
      )}
      {isBoardPaper && (data.dateFrom || Number(data.periodMonths) > 0) && (
        <Typography sx={{ color: "#7b809a", fontSize: 11.5, mt: 0.5, lineHeight: 1.4 }}>
          The period scopes the news &amp; emerging themes analysed. Watch-list risk positions
          always reflect their current assessment.
        </Typography>
      )}
      {error && (
        <Typography sx={{ color: "#c62828", fontSize: 12.5, mt: 0.75 }}>{error}</Typography>
      )}
      {isBoardPaper && busy && (
        <Typography sx={{ color: "#7b809a", fontSize: 12, mt: 0.75, fontStyle: "italic" }}>
          Drafting your board paper from the live portfolio — this can take up to a minute.
        </Typography>
      )}
      <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
        <Button
          size="small"
          variant="contained"
          disabled={busy}
          onClick={onConfirm}
          startIcon={busy ? <CircularProgress size={14} color="inherit" /> : <AddIcon />}
          sx={{
            bgcolor: "#52009b",
            color: "#fff",
            textTransform: "none",
            "&:hover": { bgcolor: "#42007e" },
          }}
        >
          {isRisk && "Add to watchlist"}
          {isBoardPaper && "Generate board paper"}
          {!isRisk && !isBoardPaper && "Create search"}
        </Button>
        <Button
          size="small"
          disabled={busy}
          onClick={onDismiss}
          sx={{ color: "#7b809a", textTransform: "none" }}
        >
          Not now
        </Button>
      </Box>
    </Box>
  );
}

// ── Main page ─────────────────────────────────────────────────────────────────

export default function RiskAdvisor() {
  const getToken = useAuthToken();
  const navigate = useNavigate();

  const [brief, setBrief] = useState(null); // { emergingThemes, activeRisks, counts } — opening feed
  const [askMessages, setAskMessages] = useState([]); // { role: 'user'|'assistant', text } — Ask PAGER thread
  const [askInput, setAskInput] = useState("");
  const [asking, setAsking] = useState(false);
  const inputRef = useRef(null);
  const focusInput = useCallback(() => {
    // Defer so it runs after the re-render that re-enables the input / finishes the click.
    setTimeout(() => inputRef.current?.focus(), 0);
  }, []);

  // Keep the typing cursor in the chat input: a disabled input (while a reply streams) drops focus,
  // so restore it as soon as streaming ends.
  useEffect(() => {
    if (!asking) focusInput();
  }, [asking, focusInput]);

  // Opening feed — latest emerging themes + watchlist risks to monitor (shown on the welcome screen).
  const loadBrief = useCallback(async () => {
    const token = await getToken();
    if (!token) return;
    try {
      const res = await fetch(`${API}/advisor/brief?themes=6&risks=6`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const json = await res.json();
      if (json?.data) setBrief(json.data);
    } catch (_) {}
  }, [getToken]);

  useEffect(() => {
    loadBrief();
  }, [loadBrief]);

  // Ask PAGER — grounded Q&A over the tenant's themes + watchlist (streams from /advisor/ask).
  const askPager = useCallback(
    async (explicit) => {
      const q = (typeof explicit === "string" ? explicit : askInput).trim();
      if (!q || asking) return;
      setAskInput("");
      const history = askMessages.slice(-8);
      setAskMessages((m) => [...m, { role: "user", text: q }, { role: "assistant", text: "" }]);
      setAsking(true);
      const token = await getToken();
      try {
        await streamMessage(`${API}/advisor/ask`, { message: q, history }, token, (ev) => {
          if (ev.type === "text_delta") {
            setAskMessages((m) => {
              const copy = m.slice();
              const last = copy[copy.length - 1];
              if (last && last.role === "assistant") {
                copy[copy.length - 1] = { ...last, text: last.text + ev.text };
              }
              return copy;
            });
          } else if (ev.type === "proposal") {
            setAskMessages((m) => {
              const copy = m.slice();
              const last = copy[copy.length - 1];
              if (last && last.role === "assistant") {
                copy[copy.length - 1] = {
                  ...last,
                  proposal: { kind: ev.kind, data: ev.data || {} },
                };
              }
              return copy;
            });
          }
        });
      } catch (_) {
        setAskMessages((m) => {
          const copy = m.slice();
          const last = copy[copy.length - 1];
          if (last && last.role === "assistant" && !last.text) {
            copy[copy.length - 1] = { ...last, text: "Sorry — I couldn't answer that just now." };
          }
          return copy;
        });
      }
      setAsking(false);
    },
    [askInput, asking, askMessages, getToken]
  );

  // Confirm a proposed action (create watchlist risk / horizon search) — POST /advisor/confirm.
  const confirmAction = useCallback(
    async (idx) => {
      const target = askMessages[idx];
      const proposal = target && target.proposal;
      if (!proposal || proposal.busy || proposal.done) return;
      setAskMessages((m) => {
        const copy = m.slice();
        if (copy[idx])
          copy[idx] = { ...copy[idx], proposal: { ...copy[idx].proposal, busy: true } };
        return copy;
      });
      const token = await getToken();
      try {
        const res = await fetch(`${API}/advisor/confirm`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          body: JSON.stringify({ kind: proposal.kind, data: proposal.data }),
        });
        const json = await res.json().catch(() => ({}));
        const ok = res.ok && json?.status !== false && json?.success !== false;
        setAskMessages((m) => {
          const copy = m.slice();
          if (copy[idx]) {
            copy[idx] = {
              ...copy[idx],
              proposal: {
                ...copy[idx].proposal,
                busy: false,
                done: ok,
                result: ok ? json?.data || {} : null,
                error: ok ? null : json?.message || "Couldn't complete that action.",
              },
            };
          }
          return copy;
        });
      } catch (_) {
        setAskMessages((m) => {
          const copy = m.slice();
          if (copy[idx])
            copy[idx] = {
              ...copy[idx],
              proposal: {
                ...copy[idx].proposal,
                busy: false,
                error: "Couldn't complete that action.",
              },
            };
          return copy;
        });
      }
    },
    [askMessages, getToken]
  );

  const dismissAction = useCallback((idx) => {
    setAskMessages((m) => {
      const copy = m.slice();
      if (copy[idx])
        copy[idx] = { ...copy[idx], proposal: { ...copy[idx].proposal, dismissed: true } };
      return copy;
    });
  }, []);

  // Generate a board paper from a confirmed board_paper proposal — drives the existing report
  // generator (POST /boardPaper/generate) with the conversational scope, then offers to open it.
  const generateBoardPaper = useCallback(
    async (idx) => {
      const target = askMessages[idx];
      const proposal = target && target.proposal;
      if (!proposal || proposal.busy || proposal.done) return;
      setAskMessages((m) => {
        const copy = m.slice();
        if (copy[idx])
          copy[idx] = {
            ...copy[idx],
            proposal: { ...copy[idx].proposal, busy: true, error: null },
          };
        return copy;
      });
      focusInput(); // clicking Generate blurs the input — give the cursor back so the user can keep chatting
      const d = proposal.data || {};
      const token = await getToken();

      // Map the natural-language length to the generator's page spec.
      const LENGTH_PAGES = { short: "1 page", standard: "2 pages", detailed: "4 pages" };

      // Resolve specific named risks → watchlist risk ids (best-effort, case-insensitive match).
      let watchlistRiskIds = [];
      if (Array.isArray(d.focusRisks) && d.focusRisks.length) {
        try {
          const lr = await fetch(`${API}/emergingRisk/list`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const lj = await lr.json().catch(() => ({}));
          const risks = Array.isArray(lj?.data) ? lj.data : [];
          const wanted = d.focusRisks.map((s) => String(s).toLowerCase().trim()).filter(Boolean);
          watchlistRiskIds = risks
            .filter((r) => {
              const title = String(r.Title || r.title || "").toLowerCase();
              return title && wanted.some((w) => title.includes(w) || w.includes(title));
            })
            .map((r) => String(r._id || r.id))
            .filter(Boolean);
        } catch (_) {
          /* fall back to category / whole-portfolio scope */
        }
      }

      // Reporting period → date range (explicit dates win; else a relative month lookback).
      let dateMode = "current";
      let dateFrom;
      let dateTo;
      if (d.dateFrom && d.dateTo) {
        dateMode = "date-range";
        dateFrom = d.dateFrom;
        dateTo = d.dateTo;
      } else if (Number(d.periodMonths) > 0) {
        const to = new Date();
        const from = new Date();
        from.setMonth(from.getMonth() - Number(d.periodMonths));
        dateMode = "date-range";
        dateFrom = from.toISOString().slice(0, 10);
        dateTo = to.toISOString().slice(0, 10);
      }

      const body = {
        reportType: ["strategic", "operational", "tactical"].includes(d.reportType)
          ? d.reportType
          : "strategic",
        scope: "all",
        includeCharts: d.includeCharts !== false,
        anticipatory: true,
        riskCategoriesL1: Array.isArray(d.focusCategories) ? d.focusCategories : [],
        riskCategoriesL2: Array.isArray(d.focusSubCategories) ? d.focusSubCategories : [],
        watchlistRiskIds,
        length: LENGTH_PAGES[d.length] || "2 pages",
        dateMode,
        dateFrom,
        dateTo,
        structure: d.notes || "",
        outputFormat: d.outputFormat === "pptx" ? "pptx" : "docx",
      };
      try {
        const res = await fetch(`${API}/boardPaper/generate`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          body: JSON.stringify(body),
        });
        const json = await res.json().catch(() => ({}));
        const ok = res.ok && json?.success !== false && json?.data?.reportId;
        setAskMessages((m) => {
          const copy = m.slice();
          if (copy[idx])
            copy[idx] = {
              ...copy[idx],
              proposal: {
                ...copy[idx].proposal,
                busy: false,
                done: !!ok,
                result: ok ? json.data : null,
                error: ok ? null : json?.message || "Couldn't generate the board paper.",
              },
            };
          return copy;
        });
      } catch (_) {
        setAskMessages((m) => {
          const copy = m.slice();
          if (copy[idx])
            copy[idx] = {
              ...copy[idx],
              proposal: {
                ...copy[idx].proposal,
                busy: false,
                error: "Couldn't generate the board paper.",
              },
            };
          return copy;
        });
      }
    },
    [askMessages, getToken]
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ display: "flex", height: "calc(100vh - 96px)", gap: 0, overflow: "hidden" }}>
        {/* ── Chat area ── */}
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
          {/* Welcome screen */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              p: 4,
            }}
          >
            <Box sx={{ maxWidth: 760, width: "100%", textAlign: "center" }}>
              <Typography variant="h5" fontWeight="bold" sx={{ color: "#52009b", mb: 0.5 }}>
                Ask PAGER
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 3, lineHeight: 1.6 }}>
                Your latest emerging themes and watchlist risks to monitor. Ask which themes moved
                or which risks are worsening — or ask me to build a board paper when you&apos;re
                ready.
              </Typography>

              {brief && (brief.emergingThemes?.length || brief.activeRisks?.length) ? (
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                    gap: 2,
                    textAlign: "left",
                    mb: 3,
                  }}
                >
                  {/* Emerging themes to watch */}
                  <Box
                    sx={{
                      border: "1px solid #e7e2ef",
                      borderRadius: 2,
                      p: 1.75,
                      bgcolor: "#faf9fc",
                    }}
                  >
                    <Typography
                      variant="overline"
                      sx={{ color: "#6a6478", fontWeight: 700, letterSpacing: 0.6 }}
                    >
                      Emerging themes to watch
                    </Typography>
                    {(brief.emergingThemes || []).map((t) => (
                      <Box
                        key={t.themeTag || t.name}
                        onClick={() => navigate("/anticipate/HorizonScan")}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          py: 0.6,
                          cursor: "pointer",
                          borderBottom: "1px solid #efeaf6",
                          "&:last-of-type": { borderBottom: "none" },
                          "&:hover .themeName": { color: "#52009b" },
                        }}
                      >
                        <Box
                          sx={{
                            flex: "none",
                            width: 24,
                            textAlign: "center",
                            fontSize: 11,
                            fontWeight: 800,
                            color: "#fff",
                            borderRadius: 0.75,
                            py: 0.15,
                            bgcolor: RATING_COLORS[t.rating] || "#9990a8",
                          }}
                        >
                          {t.rating || "–"}
                        </Box>
                        <Typography
                          className="themeName"
                          variant="body2"
                          sx={{ flex: 1, lineHeight: 1.3 }}
                        >
                          {t.name}
                        </Typography>
                        {t.newAlertsToday > 0 && (
                          <Box
                            sx={{
                              flex: "none",
                              fontSize: 10.5,
                              fontWeight: 700,
                              color: "#0a5bb0",
                            }}
                          >
                            +{t.newAlertsToday} today
                          </Box>
                        )}
                      </Box>
                    ))}
                    {!(brief.emergingThemes || []).length && (
                      <Typography variant="body2" color="text.secondary" sx={{ py: 0.5 }}>
                        No rated themes yet.
                      </Typography>
                    )}
                  </Box>

                  {/* Watchlist risks to monitor */}
                  <Box
                    sx={{
                      border: "1px solid #e7e2ef",
                      borderRadius: 2,
                      p: 1.75,
                      bgcolor: "#faf9fc",
                    }}
                  >
                    <Typography
                      variant="overline"
                      sx={{ color: "#6a6478", fontWeight: 700, letterSpacing: 0.6 }}
                    >
                      Watchlist risks to monitor
                    </Typography>
                    {(brief.activeRisks || []).map((r) => (
                      <Box
                        key={r.id || r.title}
                        onClick={() => navigate("/anticipate/EmergingRisks")}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          py: 0.6,
                          cursor: "pointer",
                          borderBottom: "1px solid #efeaf6",
                          "&:last-of-type": { borderBottom: "none" },
                          "&:hover .riskName": { color: "#52009b" },
                        }}
                      >
                        <Typography
                          className="riskName"
                          variant="body2"
                          sx={{ flex: 1, lineHeight: 1.3 }}
                        >
                          {r.title}
                        </Typography>
                        {r.trendDirection === "worsening" && (
                          <Box
                            sx={{
                              flex: "none",
                              fontSize: 10.5,
                              fontWeight: 700,
                              color: "#c62828",
                            }}
                          >
                            ⚠ worsening
                          </Box>
                        )}
                        {r.trendDirection === "improving" && (
                          <Box
                            sx={{
                              flex: "none",
                              fontSize: 10.5,
                              fontWeight: 700,
                              color: "#2c7a50",
                            }}
                          >
                            ✓ improving
                          </Box>
                        )}
                      </Box>
                    ))}
                    {!(brief.activeRisks || []).length && (
                      <Typography variant="body2" color="text.secondary" sx={{ py: 0.5 }}>
                        No active watchlist risks.
                      </Typography>
                    )}
                  </Box>
                </Box>
              ) : null}

              {/* Ask PAGER thread */}
              {askMessages.length > 0 && (
                <Box
                  sx={{
                    textAlign: "left",
                    mb: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                  }}
                >
                  {askMessages.map((m, i) => (
                    <React.Fragment key={i}>
                      {(m.text || m.role === "user" || !(m.proposal && !m.proposal.dismissed)) && (
                        <Box
                          sx={{
                            alignSelf: m.role === "user" ? "flex-end" : "flex-start",
                            maxWidth: "85%",
                            bgcolor: m.role === "user" ? "#52009b" : "#f3eefa",
                            color: m.role === "user" ? "#fff" : "#222028",
                            borderRadius: 2,
                            px: 1.5,
                            py: 1,
                            fontSize: 14,
                            whiteSpace: "pre-wrap",
                            lineHeight: 1.5,
                          }}
                        >
                          {m.text || (asking && i === askMessages.length - 1 ? "…" : "")}
                        </Box>
                      )}
                      {m.proposal && !m.proposal.dismissed && (
                        <ProposalCard
                          proposal={m.proposal}
                          onConfirm={() =>
                            m.proposal.kind === "board_paper"
                              ? generateBoardPaper(i)
                              : confirmAction(i)
                          }
                          onDismiss={() => dismissAction(i)}
                          onOpen={(riskId) =>
                            navigate("/anticipate/EmergingRisks", {
                              state: { openRiskId: riskId },
                            })
                          }
                          onOpenBoardPaper={(reportId) =>
                            navigate(`/anticipate/board-paper?view=${reportId}`)
                          }
                        />
                      )}
                    </React.Fragment>
                  ))}
                </Box>
              )}

              {/* Ask input */}
              <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                <TextField
                  fullWidth
                  size="small"
                  inputRef={inputRef}
                  placeholder="Ask about today's risks — which themes moved, which risks are worsening…"
                  value={askInput}
                  onChange={(e) => setAskInput(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      askPager();
                    }
                  }}
                  disabled={asking}
                />
                <IconButton
                  onClick={askPager}
                  disabled={asking || !askInput.trim()}
                  sx={{
                    bgcolor: "#52009b",
                    color: "#fff",
                    "&:hover": { bgcolor: "#42007c" },
                    "&.Mui-disabled": { bgcolor: "#e7e2ef" },
                  }}
                >
                  {asking ? <CircularProgress size={18} color="inherit" /> : <SendIcon />}
                </IconButton>
              </Box>

              {/* Suggested starters (shown on the empty chat) */}
              {askMessages.length === 0 && (
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1,
                    justifyContent: "center",
                    mb: 2,
                  }}
                >
                  {[
                    "What's emerging this week?",
                    "Which 3 themes should the board care about?",
                    "Which risks are worsening?",
                    "Build me a board paper",
                  ].map((s) => (
                    <Button
                      key={s}
                      size="small"
                      variant="outlined"
                      disabled={asking}
                      onClick={() => askPager(s)}
                      sx={{
                        textTransform: "none",
                        color: "#52009b",
                        borderColor: "#d8c7ec",
                        bgcolor: "#fff",
                        "&:hover": { borderColor: "#52009b", bgcolor: "#f7f2fb" },
                      }}
                    >
                      {s}
                    </Button>
                  ))}
                </Box>
              )}

              {askMessages.length > 0 && (
                <Button
                  variant="outlined"
                  size="medium"
                  startIcon={<AddIcon />}
                  onClick={() => {
                    setAskMessages([]);
                    setAskInput("");
                  }}
                  sx={{
                    color: "#7b1fa2",
                    borderColor: "#c9a8e0",
                    "&:hover": { borderColor: "#7b1fa2", bgcolor: "#f7f2fb" },
                    textTransform: "none",
                    px: 3,
                  }}
                >
                  New chat
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </DashboardLayout>
  );
}
